import React, {useEffect, useState} from 'react';
import {requestDashboard} from '../api/api';
import {MenuItem} from './dashboard/types';

interface PublicMenuProps { apiBase: string }

export const PublicMenu: React.FC<PublicMenuProps> = ({apiBase}) => {
  const [items, setItems] = useState<MenuItem[]>([]);
  const [error, setError] = useState('');
  useEffect(() => {
    requestDashboard<MenuItem[]>({apiBase, path: '/menu-items'})
      .then(setItems).catch(e => setError(e instanceof Error ? e.message : 'Unable to load the menu.'));
  }, [apiBase]);
  const groups = [{key: 'food', label: 'Food'}, {key: 'drink', label: 'Drinks'}] as const;
  return <main className='public-menu-page'>
    <header className='public-menu-hero'><p className='eyebrow'>Nook restaurant</p><h1>Our Menu</h1><p>Freshly prepared food and drinks, made for good company.</p></header>
    {error ? <p className='public-menu-message'>{error}</p> : groups.map(group => {
      const groupItems = items.filter(item => item.category === group.key);
      if (!groupItems.length) return null;
      return <section className='public-menu-section' key={group.key}><h2>{group.label}</h2><div className='public-menu-grid'>{groupItems.map(item => <article className='public-menu-card' key={item.id}>
        {item.imageUrl && <img src={item.imageUrl} alt={item.name}/>}<div><div className='public-menu-title'><h3>{item.name}</h3><strong>{item.priceGlass ? `Glass ${Number(item.priceGlass).toLocaleString()}` : ''}{item.priceGlass && item.priceBottle ? ' · ' : ''}{item.priceBottle ? `Bottle ${Number(item.priceBottle).toLocaleString()}` : `$${Number(item.price).toFixed(2)}`}</strong></div>{item.description && <p>{item.description}</p>}{item.menuSection && <small>{item.menuSection}</small>}</div>
      </article>)}</div></section>;
    })}
    {!error && items.length === 0 && <p className='public-menu-message'>Our menu is being prepared. Please check back soon.</p>}
  </main>;
};
